import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, ROW_COUNT, API_ADMIN_TIPO_PROCESO, API_ADMIN_AREA_RESPONSABLE } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { IAreaResponsable } from "../../../entities/IAreaResponsable";
import { ITipoProceso } from "../../../entities/ITipoProceso";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";

interface ITipoProcesoProps {
  cbAreaResponsable?: Array<IAreaResponsable>;
}

const TipoProceso = ({ cbAreaResponsable }: ITipoProcesoProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboAr, setComboAr] = useState<Array<IAreaResponsable>>(cbAreaResponsable || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let paramsActive = cParamsActiveOrderTitle;
    let result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_AREA_RESPONSABLE}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result
      .data;
    setComboAr(combo);
    setIsLoading(false);
  }, [token]);
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<ITipoProceso>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.AREA_RESPONSABLE = filter.ID_AREA_RESPONSABLE?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: ITipoProceso, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    value.ID_AREA_RESPONSABLE = value.ID_AREA_RESPONSABLE || 1;

    postAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID !== undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //ID_AREA_RESPONSABLE
  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
              ID_AREA_RESPONSABLE: 1,
              AREA_RESPONSABLE: "",
            },
            {}
          );
          filter(false as unknown as Partial<ITipoProceso>, false, 1);
          paging(1);
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_AREA_RESPONSABLE",
            value: comboAr.map((ar) => {
              return { text: ar.TITULO, value: ar.ID };
            }),
          },
        ]}
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"TipoProceso"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Tipo de proceso"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default TipoProceso;
